import React, { useEffect, useState, useCallback, useMemo } from "react";
import Table from "../../common/Table/table";
import ApptModalCommon from "./ApptModalCommon";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  getAppointmentSlice,
  resetgetAppointment,
  cancelAppointment,
  resetCancelMessage,
} from "../../../store/slices/appointmentSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
const Appointments = () => {
  const [showModal, setModalVisible] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const navigate = useNavigate();

  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [reportFromData, setReportFromData] = useState({
    fromDate: "",
    toDate: "",
  });
  const [shouldReset, setShouldReset] = useState(false);
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const dispatch = useDispatch();
  const {
    appointments,
    searchMessage,
    currentPage,
    totalPages,
    totalCount,
    cancelSuccessMessage,
    cancelErrorMessage,
    loading,
  } = useSelector((state) => state.appointmentSlice);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const clinicId = clinicInfo?.[0]?.clinicId ;
  console.log(appointments);
  
  const fetchAppointments = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getAppointmentSlice({
            clinicId,
            token,
            currentPage: page,
            limit: lim,
            searchQuery: search || undefined,
            fromDate: reportFromData.fromDate || undefined,
            toDate: reportFromData.toDate || undefined,
          }),
        );
      }
    },
    [
      dispatch,
      clinicInfo,
      token,
      pageLimit,
      searchValue,
      reportFromData.fromDate,
      reportFromData.toDate,
    ],
  );
  useEffect(() => {
    if (clinicId && token) {
      dispatch(resetgetAppointment());
      fetchAppointments(1, pageLimit, searchValue);
    }
  }, [
    clinicInfo,
    token,
    showModal,
    pageLimit,
    searchValue,
    fetchAppointments,
    dispatch,
  ]);

  const handlePageChange = (page) => {
    fetchAppointments(page, pageLimit, searchValue);
  };

  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchAppointments(1, newLimit, searchValue);
  };

  const tableHead = useMemo(
    () => [
      { title: "App Id", key: "appointmentId" },
      { title: "Name", key: "patientName", searchable: true },
      { title: "Services", key: "services" },
      { title: "Details", key: "details" },
      { title: "Appt Date", key: "appointmentDate", searchable: true },
      { title: "Status", key: "status" },
    ],
    [],
  );

  useEffect(() => {
    showTostifyMessageAndReset(
      cancelSuccessMessage,
      showToastifySuccess,
      resetCancelMessage,
    );
    showTostifyMessageAndReset(
      cancelErrorMessage,
      showToastifyError,
      resetCancelMessage,
    );
  }, [
    cancelSuccessMessage,
    cancelErrorMessage,
    dispatch,
    showTostifyMessageAndReset,
  ]);
  const tableBody = useMemo(
    () =>
      appointments?.map((appointment) => {
        const serviceDetails = [
          ...(appointment?.tests || []),
          ...(appointment?.profiles || []),
          ...(appointment?.dentalServices || []),
          ...(appointment?.hairServices || []),
          ...(appointment?.skinServices || []),
          ...(appointment?.generalServices || []),
          ...(appointment?.physiotherapyService || []),
          ...(appointment?.radioServices?.flatMap(
            (item) => item?.radiologyServiceInfo?.serviceDetails || [],
          ) || []),
        ];
        const details =
          [
            ...(appointment?.tests?.map((t) => t?.testId?.testName) || []),
            ...(appointment?.profiles?.map((p) => p?.profileId?.profileName) ||
              []),
            ...(appointment?.dentalServices?.map(
              (d) => d?.dentalId?.serviceName,
            ) || []),
            ...(appointment?.hairServices?.map((h) => h?.hairId?.serviceName) ||
              []),
            ...(appointment?.skinServices?.map((s) => s?.skinId?.serviceName) ||
              []),
            ...(appointment?.generalServices?.map(
              (g) => g?.generalId?.serviceName,
            ) || []),
            ...(appointment?.physiotherapyService?.map(
              (p) => p?.physioId?.serviceDetailName,
            ) || []),
            ...(appointment?.radioServices?.flatMap(
              (r) =>
                r?.radiologyServiceInfo?.serviceName,
            ) || []),
          ]
            .filter(Boolean)
            .join(", ") ||
          appointment?.consultationDetails?.physicianId?.userId?.name ||
          "No details available";

        return {
          appointmentId: appointment.appointmentId,
          patientName: appointment?.patientId?.userId?.name || "Unknown",
          appointmentDate: new Date(appointment.appDate)
            .toISOString()
            .split("T")[0],
          services: appointment?.service?.serviceName || "No service specified",
          details,
          status: appointment.status,
          cancelReason: appointment.cancelReason || "",
        };
      }),
    [appointments],
  );

  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchValue(value);
      fetchAppointments(1, pageLimit, value);
    },
    [fetchAppointments, pageLimit],
  );

  const handleFilter = useCallback(async () => {
    await dispatch(
      getAppointmentSlice({
        clinicId,
        fromDate: reportFromData.fromDate,
        toDate: reportFromData.toDate,
        token,
        currentPage: 1,
        limit: pageLimit,
      }),
    );
  }, [dispatch, clinicInfo, reportFromData, token, pageLimit]);

  const handleClear = useCallback(async () => {
    setReportFromData({ fromDate: "", toDate: "" });
    fetchAppointments(1, pageLimit, searchValue);
  }, [fetchAppointments, pageLimit, searchValue]);

  const handleSorting = useCallback(
    async (names, order) => {
      if (names === "Name") {
        await dispatch(
          getAppointmentSlice({
            clinicId,
            token,
            currentPage: 1,
            limit: pageLimit,
            sortByName: order,
            sortByDate: "",
          }),
        );
      } else if (names === "Appt Date") {
        await dispatch(
          getAppointmentSlice({
            clinicId,
            token,
            currentPage: 1,
            limit: pageLimit,
            sortByDate: order,
            sortByName: "",
          }),
        );
      }
    },
    [dispatch, clinicInfo, token, pageLimit],
  );

  const handleCancel = (appointment) => {
    setSelectedAppointmentId(appointment.appointmentId);
    setCancelReason(appointment.cancelReason || "");
    setDeleteModal(true);
  };

  const confirmCancel = async () => {
    if (!cancelReason) {
      showToastifyError("Please select a reason before cancelling.");
      return;
    }

    try {
      await dispatch(
        cancelAppointment({
          appointmentId: selectedAppointmentId,
          clinicId,
          cancelledBy: "Clinic",
          cancelReason,
          token,
        }),
      );
      setDeleteModal(false);
      setCancelReason("");
      fetchAppointments();
    } catch (error) {
      console.error("Error occurred while cancelling:", error);
    }
  };

  const handlePrint = (row) => {
    const serviceName = row.services;
    if (serviceName.toLowerCase() === "consultation") {
      navigate(`/viewPrescription`);
      sessionStorage.setItem("appointmentId", row?.appointmentId);
    } else {
      showToastifyError(
        "Prescription available only for consultation service.",
      );
    }
  };

  return (
    <>
      <div className="row d-flex align-items-center mb-4">
        <div className="col-md-3">
          <div className="form-group form-focus focused">
            <label className="focus-label">From</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.fromDate}
                onChange={(e) =>
                  setReportFromData((prev) => ({
                    ...prev,
                    fromDate: e.target.value,
                  }))
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group form-focus focused">
            <label className="focus-label">To</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.toDate}
                onChange={(e) =>
                  setReportFromData((prev) => ({
                    ...prev,
                    toDate: e.target.value,
                  }))
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <button className="btn btn-primary mt-3" onClick={handleFilter}>
            Filter
          </button>
          <button className="btn btn-danger mt-3 ms-3" onClick={handleClear}>
            Clear
          </button>
        </div>
      </div>
      <Table
        tableHead={tableHead}
        addModal={() => {
          setShouldReset(true);
          setModalVisible(true);
        }}
        tableBody={tableBody}
        handleAddBtn={true}
        errorMessage={searchMessage}
        searchValue={searchValue}
        handleSearch={handleSearch}
        handleSorting={handleSorting}
        handleCancel={handleCancel}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
        handlePrint={handlePrint}
      />

      <ApptModalCommon
        setModalVisible={setModalVisible}
        showModal={showModal}
        shouldReset={shouldReset}
        setShouldReset={setShouldReset}
      />
      <Modal centered show={deleteModal} onHide={() => setDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Are You Sure Want to Cancel it?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>Select Reason for Cancellation</label>
            <select
              className="form-control"
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
            >
              <option value="">-- Select Reason --</option>
              <option value="Patient Cancelled">Patient Cancelled</option>
              <option value="Physician Cancelled">Physician Cancelled</option>
              <option value="Facility unAvailable">Facility unAvailable</option>
              <option value="Wrong Entry">Wrong Entry</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setDeleteModal(false)}
            className="p-2"
          >
            Back to Page
          </Button>
          <Button variant="danger" className="p-2" onClick={confirmCancel}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Appointments;
